// 기존 이미지 경로 재사용
import { default as SizeRecommendExampleEn } from '../../../../../size-recommendation/assets/images/sizeRecommendExample_en.png';
import { default as SizeRecommendExampleJa } from '../../../../../size-recommendation/assets/images/sizeRecommendExample_ja.png';
import { default as SizeRecommendExampleKo } from '../../../../../size-recommendation/assets/images/sizeRecommendExample_ko.png';

export const SizeRecommendExample = {
  en: SizeRecommendExampleEn,
  ja: SizeRecommendExampleJa,
  ko: SizeRecommendExampleKo,
};
